export default __webpack_public_path__ + "static/media/3.74d368b9.png";